module.exports = __webpack_public_path__ + "img/brand (32).00ce1961.png";